import { ELegalDocumentsRoute } from '@/types/ELegalDocumentsRoute'
import { messages } from './messages'
import type { Requisite } from './types'

export const REQUISITES: Readonly<Requisite[]> = [
  {
    label: messages.requisites.company.label,
    value: messages.requisites.company.value,
    key: 'company',
  },
  {
    label: messages.requisites.legalAddress.label,
    value: messages.requisites.legalAddress.value,
    key: 'legalAddress',
  },
  {
    label: messages.requisites.mailingAddress.label,
    value: messages.requisites.mailingAddress.value,
    key: 'mailingAddress',
  },
  {
    label: messages.requisites.phone.label,
    value: messages.requisites.phone.value,
    key: 'phone',
  },
  {
    label: messages.requisites.email.label,
    value: messages.requisites.email.value,
    key: 'email',
  },
  {
    label: messages.requisites.registrationDate.label,
    value: messages.requisites.registrationDate.value,
    key: 'registrationDate',
  },
  {
    label: messages.requisites.inn.label,
    value: messages.requisites.inn.value,
    key: 'inn',
  },
  {
    label: messages.requisites.kpp.label,
    value: messages.requisites.kpp.value,
    key: 'kpp',
  },
  {
    label: messages.requisites.ogrn.label,
    value: messages.requisites.ogrn.value,
    key: 'ogrn',
  },
  {
    label: messages.requisites.okpo.label,
    value: messages.requisites.okpo.value,
    key: 'okpo',
  },
  {
    label: messages.requisites.okved.label,
    value: messages.requisites.okved.value,
    key: 'okved',
  },
  {
    label: messages.requisites.generalManager.label,
    value: messages.requisites.generalManager.value,
    key: 'generalManager',
  },
  {
    label: messages.requisites.chiefAccountant.label,
    value: messages.requisites.chiefAccountant.value,
    key: 'chiefAccountant',
  },
  {
    label: messages.requisites.bik.label,
    value: messages.requisites.bik.value,
    key: 'bik',
  },
  {
    label: messages.requisites.bank.label,
    value: messages.requisites.bank.value,
    key: 'bank',
  },
  {
    label: messages.requisites.billingAccount.label,
    value: messages.requisites.billingAccount.value,
    key: 'billingAccount',
  },
  {
    label: messages.requisites.correspondentAccount.label,
    value: messages.requisites.correspondentAccount.value,
    key: 'correspondentAccount',
  },
]

export const SPECIAL_ASSESSMENT_OF_WORKING_CONDITIONS_DOCUMENT_LINK = ELegalDocumentsRoute.WORKING_CONDDITIONS
